import { createContext } from "react";

export const ApiDataContext = createContext({});
